export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-microphone-1b35aaa65487fcf18b45e03578287abd.svg";